module.exports = __webpack_public_path__ + "img/points_event.971db916.svg";